export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/96b5356497d7cf68de56da40f562938b.png";